import {
  put,
  select,
  call,
  take,
  // cancelled,
  race,
  // all,
} from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import { userRolesSelector } from "../../selectors/external";
import {
  NEW_CALL_DETECTED,
  CALL_FINISHED,
  SYNC_FOR_NEW_CALLS_ERROR,
  OKTELL_WS_OPENED,
  OKTELL_WS_CLOSED,
  OKTELL_WS_ERROR,
  SEND_WS_MESSAGE,
  START_LISTEN_FOR_CALLS,
  // START_LISTEN_FOR_CALLS_SUCCESS,
  STOP_LISTEN_FOR_CALLS,
  // START_LISTEN_FOR_CALLS_REJECTED,
  CALL_STATUS_STARTED,
  CALL_STATUS_FINISHED,
} from "../../CONSTANTS";

export function getWSChannel({ socket, oktellUserName }) {
  return eventChannel((emit) => {
    // init the connection here
    window.wstest = socket;
    socket.onopen = () => {
      emit({ type: OKTELL_WS_OPENED });
    };
    socket.onerror = (e) => {
      return emit({ type: OKTELL_WS_ERROR, payload: { event: e } });
    };
    socket.onclose = (e) => {
      let reopen = false;
      if (!e.wasClean || e.code !== 1000) {
        reopen = true;
        return emit({ type: OKTELL_WS_ERROR, payload: { event: e } });
      }
      return emit({ type: OKTELL_WS_CLOSED, reopen });
    };
    socket.onmessage = (e) => {
      const message = e.data && JSON.parse(e.data);
      const origin = e.origin;
      const timeStamp = e.timeStamp;
      if (message["operator_name"] === oktellUserName) {
        if (message.status === CALL_STATUS_STARTED) {
          return emit({
            type: NEW_CALL_DETECTED,
            payload: {
              callId: message["client_phone"],
              clientPhone: message["client_phone"],
              operatorName: message["operator_name"],
              operatorPhone: message["operator_phone"],
              status: CALL_STATUS_STARTED,
              origin,
              timeStamp,
            },
          });
        }
        if (message.status === CALL_STATUS_FINISHED) {
          return emit({
            type: CALL_FINISHED,
            payload: {
              callId: message["client_phone"],
              status: CALL_STATUS_FINISHED,
              clientPhone: message["client_phone"],
              operatorName: message["operator_name"],
              operatorPhone: message["operator_phone"],
            },
          });
        }
      }
    };
    // unsubscribe function
    return () => {
      // it is not necessery to close socket here since it's already closed by the time it executes
      // but in case recieveMessage fails and does not close the socket
      socket.close();
    };
  });
}

function* sendMessageWatcher(socket) {
  try {
    while (true) {
      const action = yield take(SEND_WS_MESSAGE);
      socket.send(JSON.stringify(action.payload));
    }
  } catch (e) {
    socket.close();
    yield put({ type: SYNC_FOR_NEW_CALLS_ERROR, payload: { error: e } });
  }
}

function* recieveMessageWatcher(channel, socket) {
  try {
    // listen for eventChannel actions here
    // those actions are, well, on the separate channel - we rethrow them later in the main event bus.
    while (true) {
      const { action, cancel } = yield race({
        action: take(channel),
        // here we recieve a stop listen action which closes the socket below
        // which in tuen produces OKTELL_WS_CLOSED action from eventChannel emitted from stopped socket
        // which get registered below and cancels this function in the main race condition
        cancel: take(STOP_LISTEN_FOR_CALLS),
      });
      if (cancel) {
        socket.close();
      } else {
        yield put(action);
      }
    }
  } catch (e) {
    socket.close();
    yield put({ type: SYNC_FOR_NEW_CALLS_ERROR, payload: { error: e } });
  }
}

export default function* wsSync({ oktellSocketUrl, storeShape = {} }) {
  try {
    const userRoles = yield select(
      userRolesSelector,
      storeShape.user ? storeShape : { user: ["user"] }
    );
    const oktellUserName = userRoles.has("callcenter")
      ? userRoles.get("callcenter").oktellUserName
      : undefined;

    // START READING HERE
    while (true) {
      // it starts when we recieve listen for calls action
      yield take(START_LISTEN_FOR_CALLS);
      // first open the socket;
      const socket = new WebSocket(oktellSocketUrl);
      // then with initOktellWebsocket factory execute the eventChannel function returning the channel
      // all event hooks from the socket are handled inside the cahnnel
      const channel = yield call(getWSChannel, {
        socket,
        oktellUserName,
      });
      // next race condition runs send and recive message watchers until the socket closes for any reason
      yield race({
        send: call(sendMessageWatcher, socket),
        // actuall eventChannel message handling happens in recieveMessageWatcher
        recieve: call(recieveMessageWatcher, channel, socket),
        cancel: take(OKTELL_WS_CLOSED),
        wserror: take(OKTELL_WS_ERROR),
        error: take(SYNC_FOR_NEW_CALLS_ERROR),
      });
      // when the race condition is resolved then close the channel
      channel.close();
      // we then continue the while loop and listen for start action
    }
  } catch (e) {
    yield put({ type: SYNC_FOR_NEW_CALLS_ERROR, payload: { error: e } });
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/oktell/wssync.js